import { Component, OnDestroy, OnInit } from '@angular/core';
import { BasePageComponent } from '../../../base-page';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IOption } from '../../../../ui/interfaces/option';

@Component({
  selector: 'page-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class PageUserProfileComponent extends BasePageComponent implements OnInit, OnDestroy {
  userInfo: any;
  userForm: UntypedFormGroup;
  gender: IOption[];
  status: IOption[];
  currentAvatar: string | ArrayBuffer;
  defaultAvatar: string;
  changes: boolean;

  constructor(
    store: Store<IAppState>,
    httpSv: HttpService,
    private formBuilder: UntypedFormBuilder
  ) {
    super(store, httpSv);

    this.pageData = {
      title: 'User profile',
      key: '',
      breadcrumbs: [
        {
          title: 'Apps',
          key: '',
          route: 'dashboard'
        },
        {
          title: 'Service pages',
          key: '',
          route: 'dashboard'
        },
        {
          title: 'User profile',
          key: ''
        }
      ]
    };
    this.gender = [
      {
        label: 'Male',
        value: 'male'
      },
      {
        label: 'Female',
        value: 'female'
      }
    ];
    this.status = [
      {
        label: 'Approved',
        value: 'approved'
      },
      {
        label: 'Pending',
        value: 'pending'
      }
    ];
    this.defaultAvatar = 'assets/content/anonymous-400.jpg';
    this.currentAvatar = this.defaultAvatar;
    this.changes = false;
  }

  ngOnInit() {
    super.ngOnInit();

    this.getData('assets/data/user-profile.json', 'userInfo', 'loadedDetect');
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  loadedDetect() {
    this.setLoaded();

    this.currentAvatar = this.userInfo.mainInfo.img;
    this.inituserForm(this.userInfo.mainInfo);
  }

  // init form
  inituserForm(data: any) {
    this.userForm = this.formBuilder.group({
      img: [this.currentAvatar],
      firstName: [data.firstName, Validators.required],
      lastName: [data.lastName, Validators.required],
      number: [data.number, Validators.required],
      address: [data.address, Validators.required],
      gender: [data.gender, Validators.required],
      age: [data.age, Validators.required],
      lastVisit: [data.lastVisit, Validators.required],
      status: [data.status, Validators.required]
    });

    // detect form changes
    this.userForm.valueChanges.subscribe(() => {
      this.changes = true;
    });
  }

  // save form data
  saveData(form: UntypedFormGroup) {
    if (form.valid) {
      this.userInfo.mainInfo = form.value;
      this.changes = false;
    }
  }

  // upload new file
  onFileChanged(inputValue: any) {
    const file: File = inputValue.target.files[0];
    const reader: FileReader = new FileReader();

    reader.onloadend = () => {
      this.currentAvatar = reader.result;
      this.changes = true;
    };

    reader.readAsDataURL(file);
  }
}
